import CustomLayout from '@/common/Layout';
import React from 'react';
import HoldRequiredPage from './components/list';

function HoldRequests() {
  return (
    <CustomLayout sider={true} tracker={true}>
      <HoldRequiredPage />
    </CustomLayout>
  );
}

export default HoldRequests;
